
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import wx from 'weixin-js-sdk';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'


export default {
components: {
cmBlank,cmLoadmore,Popup,Group,PopupHeader,XButton,Radio,Datetime, wx
},
directives: {
TransferDom
},
data () {
return {
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
showQuery:false,
phone:'',
orderCode:'',
pageFlag:2,
hasNext:0,
lastId:0,
list:[],
sendList:[],
sendCode:'',
isActive:0,
statusArr:[
{
key:0,
num:0,
value:'已出厂待发货',
},
{
key:1,
num:0,
value:'已发货待揽收',
},
{
key:2,
num:0,
value:'已揽收',
},
],
}
},
computed: {
isMultipleCid() {
if (this.sendList.length <= 1) return false;
const cids = new Set(this.sendList.map(item => item.cid));
return cids.size > 1;
}
},
created(){

this.config();

this.getWaybillCodeCount();

},
amount(){
this.phone = '';
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
resetSearch(){
this.phone = '';
this.orderCode = '';
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.loadmore();
},
searchSubmit(){
this.lastId = 0;
this.pageFlag = 2;
this.list = [];
this.loadmore();
},
selectStatus(val){
this.isActive = val;
this.search();
},
queryExpress(code){
this.$router.push({name:'queryExpress',params:{code:code}})
},
scanQRCode(key){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(() => {
if(key === 1){
if(!that.isActive){
that.phone = res.resultStr.split(',')[1];
}else{
that.orderCode = res.resultStr.split(',')[1];
let prefix = that.orderCode.substring(0,4);
if(prefix == 'JDVG'){
that.orderCode = that.orderCode.substring(0,15);
}
}
that.search();
}else{
that.sendCode = res.resultStr.split(',')[1];
that.getCodeInfo();
}
}, 300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
getCodeInfo() {
let that = this;
if(!this.sendCode) return;
let isExist = this.sendList.find(item => item.washing_code === this.sendCode);
if(isExist){
this.$func.showToast('该衣物已经在发货列表中');



return false;
}
this.$api.getCodeInfo({code:this.sendCode}).then((res)=>{
if(res && res.data){
that.sendList.push(res.data);
if(that.isMultipleCid) {
that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
}else{
setTimeout(() => {
that.scanQRCode(0);
}, 300);
}
}
})
},
getCidColor(cid) {
if (!cid) return '#ffffff';
const colors = ['#f0faff', '#f6ffed', '#fff7e6', '#fff1f0', '#f9f0ff', '#feffe6'];

const index = typeof cid === 'number' ? cid : cid.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
return colors[index % colors.length];
},
remove(index) {
this.sendList.splice(index, 1);
},
getWaybillCodeCount(){
this.$api.getWaybillCodeCount({phone:this.phone,i:3}).then((res)=>{
if(res){
this.statusArr.forEach((item)=>{
item.num = res.data[item.key] || 0;;
})
console.log(this.statusArr);
}
})
},
getList(){
if(!this.isActive){
this.$api.waitWaybillCode({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,i:3}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
}else{
this.$api.waybillCodeList({last_id:this.lastId,page_flag:this.pageFlag,code:this.orderCode,status:this.isActive}).then((res)=>{
if(res){
if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
}
},
barOrder(code){
this.$router.push({name:'barOrder',params:{code:code}})
},
sendWaybillCode(){
let that = this;
if(!this.sendList.length){
this.$func.showToast('请选择发货衣物');
return false;
}
if(that.isMultipleCid) {
that.$func.showToast('检测到多个不同社区的衣物，请注意区分');
return false;
}
let codes = [];
this.sendList.forEach((item)=>{
codes.push({code:item.washing_code,cid:item.cid});
});
this.$func.confirm('确定物流下单送衣？','提示',()=>{
that.$api.sendWaybillCode({param:JSON.stringify(codes)}).then((res)=>{
if(res){
that.$func.showToast('物流下单成功');
that.sendList = [];
that.showQuery = false;
setTimeout(()=>{
that.search();
that.getWaybillCodeCount();
}, 300);
}
});
})
},
cancelWaybillOrder(id){
let that = this;
this.$func.confirm('确定取消订单？','提示',()=>{
that.$api.cancelWaybillOrder({id:id}).then((res)=>{
if(res){
that.$func.showToast('取消订单成功');
that.sendList = [];
that.showQuery = false;
setTimeout(()=>{
that.search();
that.getWaybillCodeCount();
}, 300);
}
});
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';
this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/waybillClotheOrder.vue